/**
 * GMA-1781 — Nora is a Command Center capability. The chat panel renders
 * only on the commandcenter hostname (any route); the legacy stg2/prod
 * frontends never show it. Runtime host gating (not a build flag) so the
 * SAME build promoted to any legacy domain hides Nora automatically — the
 * proven pattern from the post-login landing fix.
 */
import { COMMAND_CENTER_HOSTS } from "./defaultHome";

export function isNoraSurface(hostname, env = process.env) {
  if (env && env.REACT_APP_NORA_DEV === "true") return true;
  const host = typeof hostname === "string" ? hostname.trim().toLowerCase() : "";
  return COMMAND_CENTER_HOSTS.includes(host);
}

export function noraSurfaceEnabled() {
  return isNoraSurface(
    typeof window !== "undefined" && window.location
      ? window.location.hostname
      : "",
  );
}
